
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $3dfc463c1d281db3$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["lWpsB","index.787779be.js","aeFLb","rust_capr_bg.d72026b8.wasm"]'));

let $a38372e2ae75f6c1$var$wasm;
function $a38372e2ae75f6c1$var$addToExternrefTable0(obj) {
    const idx = $a38372e2ae75f6c1$var$wasm.__externref_table_alloc();
    $a38372e2ae75f6c1$var$wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}
function $a38372e2ae75f6c1$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $a38372e2ae75f6c1$var$addToExternrefTable0(e);
        $a38372e2ae75f6c1$var$wasm.__wbindgen_exn_store(idx);
    }
}
const $a38372e2ae75f6c1$var$cachedTextDecoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-8", {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: ()=>{
        throw Error("TextDecoder not available");
    }
};
if (typeof TextDecoder !== "undefined") $a38372e2ae75f6c1$var$cachedTextDecoder.decode();
let $a38372e2ae75f6c1$var$cachedUint8ArrayMemory0 = null;
function $a38372e2ae75f6c1$var$getUint8ArrayMemory0() {
    if ($a38372e2ae75f6c1$var$cachedUint8ArrayMemory0 === null || $a38372e2ae75f6c1$var$cachedUint8ArrayMemory0.byteLength === 0) $a38372e2ae75f6c1$var$cachedUint8ArrayMemory0 = new Uint8Array($a38372e2ae75f6c1$var$wasm.memory.buffer);
    return $a38372e2ae75f6c1$var$cachedUint8ArrayMemory0;
}
function $a38372e2ae75f6c1$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $a38372e2ae75f6c1$var$cachedTextDecoder.decode($a38372e2ae75f6c1$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
let $a38372e2ae75f6c1$var$WASM_VECTOR_LEN = 0;
const $a38372e2ae75f6c1$var$cachedTextEncoder = typeof TextEncoder !== "undefined" ? new TextEncoder("utf-8") : {
    encode: ()=>{
        throw Error("TextEncoder not available");
    }
};
const $a38372e2ae75f6c1$var$encodeString = typeof $a38372e2ae75f6c1$var$cachedTextEncoder.encodeInto === "function" ? function(arg, view) {
    return $a38372e2ae75f6c1$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    const buf = $a38372e2ae75f6c1$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $a38372e2ae75f6c1$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $a38372e2ae75f6c1$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $a38372e2ae75f6c1$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $a38372e2ae75f6c1$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $a38372e2ae75f6c1$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $a38372e2ae75f6c1$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $a38372e2ae75f6c1$var$encodeString(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $a38372e2ae75f6c1$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
let $a38372e2ae75f6c1$var$cachedDataViewMemory0 = null;
function $a38372e2ae75f6c1$var$getDataViewMemory0() {
    if ($a38372e2ae75f6c1$var$cachedDataViewMemory0 === null || $a38372e2ae75f6c1$var$cachedDataViewMemory0.buffer.detached === true || $a38372e2ae75f6c1$var$cachedDataViewMemory0.buffer.detached === undefined && $a38372e2ae75f6c1$var$cachedDataViewMemory0.buffer !== $a38372e2ae75f6c1$var$wasm.memory.buffer) $a38372e2ae75f6c1$var$cachedDataViewMemory0 = new DataView($a38372e2ae75f6c1$var$wasm.memory.buffer);
    return $a38372e2ae75f6c1$var$cachedDataViewMemory0;
}
function $a38372e2ae75f6c1$var$isLikeNone(x) {
    return x === undefined || x === null;
}
const $a38372e2ae75f6c1$var$CLOSURE_DTORS = typeof FinalizationRegistry === "undefined" ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((state)=>{
    $a38372e2ae75f6c1$var$wasm.__wbindgen_export_6.get(state.dtor)(state.a, state.b);
});
function $a38372e2ae75f6c1$var$makeMutClosure(arg0, arg1, dtor, f) {
    const state = {
        a: arg0,
        b: arg1,
        cnt: 1,
        dtor: dtor
    };
    const real = (...args)=>{
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally{
            if (--state.cnt === 0) {
                $a38372e2ae75f6c1$var$wasm.__wbindgen_export_6.get(state.dtor)(a, state.b);
                $a38372e2ae75f6c1$var$CLOSURE_DTORS.unregister(state);
            } else state.a = a;
        }
    };
    real.original = state;
    $a38372e2ae75f6c1$var$CLOSURE_DTORS.register(real, state, state);
    return real;
}
function $a38372e2ae75f6c1$var$_assertClass(instance, klass) {
    if (!(instance instanceof klass)) throw new Error(`expected instance of ${klass.name}`);
}
function $a38372e2ae75f6c1$var$getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = $a38372e2ae75f6c1$var$getDataViewMemory0();
    const result = [];
    for(let i = ptr; i < ptr + 4 * len; i += 4)result.push($a38372e2ae75f6c1$var$wasm.__wbindgen_export_2.get(mem.getUint32(i, true)));
    $a38372e2ae75f6c1$var$wasm.__externref_drop_slice(ptr, len);
    return result;
}
function $a38372e2ae75f6c1$export$a7b0fdfe265e688f(s) {
    let deferred2_0;
    let deferred2_1;
    try {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(s, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_xsampa_to_ipa(ptr0, len0);
        deferred2_0 = ret[0];
        deferred2_1 = ret[1];
        return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
    } finally{
        $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
}
function $a38372e2ae75f6c1$var$passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    for(let i = 0; i < array.length; i++){
        const add = $a38372e2ae75f6c1$var$addToExternrefTable0(array[i]);
        $a38372e2ae75f6c1$var$getDataViewMemory0().setUint32(ptr + 4 * i, add, true);
    }
    $a38372e2ae75f6c1$var$WASM_VECTOR_LEN = array.length;
    return ptr;
}
function $a38372e2ae75f6c1$export$10c2eb859e6cf618(left, right, from, to) {
    const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(left, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr1 = $a38372e2ae75f6c1$var$passStringToWasm0(right, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len1 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr2 = $a38372e2ae75f6c1$var$passStringToWasm0(from, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len2 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr3 = $a38372e2ae75f6c1$var$passStringToWasm0(to, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len3 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ret = $a38372e2ae75f6c1$var$wasm.create_law(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
}
function $a38372e2ae75f6c1$export$296ff20ef949ab4d(left, right, from, to) {
    const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(left, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr1 = $a38372e2ae75f6c1$var$passStringToWasm0(right, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len1 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr2 = $a38372e2ae75f6c1$var$passStringToWasm0(from, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len2 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr3 = $a38372e2ae75f6c1$var$passStringToWasm0(to, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len3 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ret = $a38372e2ae75f6c1$var$wasm.create_law_async(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return ret;
}
function $a38372e2ae75f6c1$export$b366fbedc27157db(left, right, from, to) {
    $a38372e2ae75f6c1$var$_assertClass(left, $a38372e2ae75f6c1$export$9354ed65840f0c28);
    $a38372e2ae75f6c1$var$_assertClass(right, $a38372e2ae75f6c1$export$9354ed65840f0c28);
    $a38372e2ae75f6c1$var$_assertClass(from, $a38372e2ae75f6c1$export$9354ed65840f0c28);
    $a38372e2ae75f6c1$var$_assertClass(to, $a38372e2ae75f6c1$export$9354ed65840f0c28);
    const ret = $a38372e2ae75f6c1$var$wasm.create_with_arbitrary_regex_ipa(left.__wbg_ptr, right.__wbg_ptr, from.__wbg_ptr, to.__wbg_ptr);
    return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
}
function $a38372e2ae75f6c1$export$387d5be8c7ef16f(left, right, from, to) {
    $a38372e2ae75f6c1$var$_assertClass(left, $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec);
    var ptr0 = left.__destroy_into_raw();
    $a38372e2ae75f6c1$var$_assertClass(right, $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec);
    var ptr1 = right.__destroy_into_raw();
    const ptr2 = $a38372e2ae75f6c1$var$passStringToWasm0(from, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len2 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr3 = $a38372e2ae75f6c1$var$passStringToWasm0(to, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len3 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ret = $a38372e2ae75f6c1$var$wasm.create_with_disjunctions(ptr0, ptr1, ptr2, len2, ptr3, len3);
    return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
}
function $a38372e2ae75f6c1$export$6e2e54c7e52d5d37(left, right, from, to) {
    const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(left, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr1 = $a38372e2ae75f6c1$var$passStringToWasm0(right, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len1 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr2 = $a38372e2ae75f6c1$var$passStringToWasm0(from, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len2 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr3 = $a38372e2ae75f6c1$var$passStringToWasm0(to, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len3 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ret = $a38372e2ae75f6c1$var$wasm.create_law_ipa(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
    return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
}
function $a38372e2ae75f6c1$export$122c7e944b226e5e(left, right, from, to) {
    $a38372e2ae75f6c1$var$_assertClass(left, $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec);
    var ptr0 = left.__destroy_into_raw();
    $a38372e2ae75f6c1$var$_assertClass(right, $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec);
    var ptr1 = right.__destroy_into_raw();
    const ptr2 = $a38372e2ae75f6c1$var$passStringToWasm0(from, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len2 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ptr3 = $a38372e2ae75f6c1$var$passStringToWasm0(to, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
    const len3 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
    const ret = $a38372e2ae75f6c1$var$wasm.create_with_disjunctions_ipa(ptr0, ptr1, ptr2, len2, ptr3, len3);
    return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
}
function $a38372e2ae75f6c1$var$__wbg_adapter_20(arg0, arg1, arg2) {
    $a38372e2ae75f6c1$var$wasm.closure294_externref_shim(arg0, arg1, arg2);
}
function $a38372e2ae75f6c1$var$__wbg_adapter_65(arg0, arg1, arg2, arg3) {
    $a38372e2ae75f6c1$var$wasm.closure347_externref_shim(arg0, arg1, arg2, arg3);
}
const $a38372e2ae75f6c1$var$DisjunctionFinalization = typeof FinalizationRegistry === "undefined" ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$a38372e2ae75f6c1$var$wasm.__wbg_disjunction_free(ptr >>> 0, 1));
class $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($a38372e2ae75f6c1$export$e1aa1e7b8f6632ec.prototype);
        obj.__wbg_ptr = ptr;
        $a38372e2ae75f6c1$var$DisjunctionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $a38372e2ae75f6c1$var$DisjunctionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $a38372e2ae75f6c1$var$wasm.__wbg_disjunction_free(ptr, 0);
    }
    /**
     * @param {string[]} strings
     * @returns {Disjunction}
     */ static new(strings) {
        const ptr0 = $a38372e2ae75f6c1$var$passArrayJsValueToWasm0(strings, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.disjunction_new(ptr0, len0);
        return $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec.__wrap(ret);
    }
    /**
     * @param {string[]} strings
     * @returns {Disjunction}
     */ static new_ipa(strings) {
        const ptr0 = $a38372e2ae75f6c1$var$passArrayJsValueToWasm0(strings, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.disjunction_new_ipa(ptr0, len0);
        return $a38372e2ae75f6c1$export$e1aa1e7b8f6632ec.__wrap(ret);
    }
}
const $a38372e2ae75f6c1$var$RegexFstFinalization = typeof FinalizationRegistry === "undefined" ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$a38372e2ae75f6c1$var$wasm.__wbg_regexfst_free(ptr >>> 0, 1));
class $a38372e2ae75f6c1$export$9354ed65840f0c28 {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($a38372e2ae75f6c1$export$9354ed65840f0c28.prototype);
        obj.__wbg_ptr = ptr;
        $a38372e2ae75f6c1$var$RegexFstFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $a38372e2ae75f6c1$var$RegexFstFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $a38372e2ae75f6c1$var$wasm.__wbg_regexfst_free(ptr, 0);
    }
    /**
     * @returns {string}
     */ string_form() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.regexfst_string_form(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} s
     * @returns {RegexFst}
     */ static new_from_ipa(s) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(s, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.regexfst_new_from_ipa(ptr0, len0);
        return $a38372e2ae75f6c1$export$9354ed65840f0c28.__wrap(ret);
    }
    /**
     * @param {number} label
     * @returns {RegexFst}
     */ static new_from_label(label) {
        const ret = $a38372e2ae75f6c1$var$wasm.regexfst_new_from_label(label);
        return $a38372e2ae75f6c1$export$9354ed65840f0c28.__wrap(ret);
    }
    /**
     * @returns {RegexFst}
     */ dup() {
        const ret = $a38372e2ae75f6c1$var$wasm.regexfst_dup(this.__wbg_ptr);
        return $a38372e2ae75f6c1$export$9354ed65840f0c28.__wrap(ret);
    }
    kleen() {
        $a38372e2ae75f6c1$var$wasm.regexfst_kleen(this.__wbg_ptr);
    }
    /**
     * @param {RegexFst} other
     */ concat(other) {
        $a38372e2ae75f6c1$var$_assertClass(other, $a38372e2ae75f6c1$export$9354ed65840f0c28);
        $a38372e2ae75f6c1$var$wasm.regexfst_concat(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
     * @returns {string}
     */ to_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.regexfst_to_json(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {RegexFst} other
     */ disjoint(other) {
        $a38372e2ae75f6c1$var$_assertClass(other, $a38372e2ae75f6c1$export$9354ed65840f0c28);
        $a38372e2ae75f6c1$var$wasm.regexfst_disjoint(this.__wbg_ptr, other.__wbg_ptr);
    }
    /**
     * @returns {boolean}
     */ is_empty() {
        const ret = $a38372e2ae75f6c1$var$wasm.regexfst_is_empty(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} s
     * @returns {RegexFst}
     */ static from_json(s) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(s, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.regexfst_from_json(ptr0, len0);
        return $a38372e2ae75f6c1$export$9354ed65840f0c28.__wrap(ret);
    }
}
const $a38372e2ae75f6c1$var$SoundLawFinalization = typeof FinalizationRegistry === "undefined" ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$a38372e2ae75f6c1$var$wasm.__wbg_soundlaw_free(ptr >>> 0, 1));
class $a38372e2ae75f6c1$export$cf2277d9f7cc728b {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($a38372e2ae75f6c1$export$cf2277d9f7cc728b.prototype);
        obj.__wbg_ptr = ptr;
        $a38372e2ae75f6c1$var$SoundLawFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $a38372e2ae75f6c1$var$SoundLawFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $a38372e2ae75f6c1$var$wasm.__wbg_soundlaw_free(ptr, 0);
    }
    ignore_meta() {
        $a38372e2ae75f6c1$var$wasm.soundlaw_ignore_meta(this.__wbg_ptr);
    }
    /**
     * @param {string} text
     * @returns {string[]}
     */ transduce_text(text) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(text, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_transduce_text(this.__wbg_ptr, ptr0, len0);
        var v2 = $a38372e2ae75f6c1$var$getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        $a38372e2ae75f6c1$var$wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {string}
     */ get_left_context() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_get_left_context(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */ get_right_context() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_get_right_context(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} text
     * @returns {string[]}
     */ transduce_text_backwards(text) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(text, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_transduce_text_backwards(this.__wbg_ptr, ptr0, len0);
        var v2 = $a38372e2ae75f6c1$var$getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        $a38372e2ae75f6c1$var$wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {string}
     */ get_to() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_get_to(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {number} label
     */ ignore(label) {
        $a38372e2ae75f6c1$var$wasm.soundlaw_ignore(this.__wbg_ptr, label);
    }
    /**
     * @returns {string}
     */ to_json() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_to_json(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @returns {string}
     */ get_from() {
        let deferred1_0;
        let deferred1_1;
        try {
            const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_get_from(this.__wbg_ptr);
            deferred1_0 = ret[0];
            deferred1_1 = ret[1];
            return $a38372e2ae75f6c1$var$getStringFromWasm0(ret[0], ret[1]);
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * @param {string} s
     * @returns {SoundLaw}
     */ static from_json(s) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(s, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlaw_from_json(ptr0, len0);
        return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
    }
}
const $a38372e2ae75f6c1$var$SoundLawCompositionFinalization = typeof FinalizationRegistry === "undefined" ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$a38372e2ae75f6c1$var$wasm.__wbg_soundlawcomposition_free(ptr >>> 0, 1));
class $a38372e2ae75f6c1$export$9ab3471fa659f5a {
    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create($a38372e2ae75f6c1$export$9ab3471fa659f5a.prototype);
        obj.__wbg_ptr = ptr;
        $a38372e2ae75f6c1$var$SoundLawCompositionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $a38372e2ae75f6c1$var$SoundLawCompositionFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $a38372e2ae75f6c1$var$wasm.__wbg_soundlawcomposition_free(ptr, 0);
    }
    /**
     * @returns {boolean}
     */ recompute_fsts() {
        const ret = $a38372e2ae75f6c1$var$wasm.soundlawcomposition_recompute_fsts(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
     * @param {string} text
     * @returns {string[]}
     */ transduce_text(text) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(text, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlawcomposition_transduce_text(this.__wbg_ptr, ptr0, len0);
        var v2 = $a38372e2ae75f6c1$var$getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        $a38372e2ae75f6c1$var$wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @param {string} text
     * @returns {string[]}
     */ transduce_text_invert(text) {
        const ptr0 = $a38372e2ae75f6c1$var$passStringToWasm0(text, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len0 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        const ret = $a38372e2ae75f6c1$var$wasm.soundlawcomposition_transduce_text_invert(this.__wbg_ptr, ptr0, len0);
        var v2 = $a38372e2ae75f6c1$var$getArrayJsValueFromWasm0(ret[0], ret[1]).slice();
        $a38372e2ae75f6c1$var$wasm.__wbindgen_free(ret[0], ret[1] * 4, 4);
        return v2;
    }
    /**
     * @returns {SoundLawComposition}
     */ static new() {
        const ret = $a38372e2ae75f6c1$var$wasm.soundlawcomposition_new();
        return $a38372e2ae75f6c1$export$9ab3471fa659f5a.__wrap(ret);
    }
    clear() {
        $a38372e2ae75f6c1$var$wasm.soundlawcomposition_clear(this.__wbg_ptr);
    }
    /**
     * @param {SoundLawComposition} other
     */ append(other) {
        $a38372e2ae75f6c1$var$_assertClass(other, $a38372e2ae75f6c1$export$9ab3471fa659f5a);
        var ptr0 = other.__destroy_into_raw();
        $a38372e2ae75f6c1$var$wasm.soundlawcomposition_append(this.__wbg_ptr, ptr0);
    }
    /**
     * @param {number} index
     * @param {SoundLaw} law
     */ insert(index, law) {
        $a38372e2ae75f6c1$var$_assertClass(law, $a38372e2ae75f6c1$export$cf2277d9f7cc728b);
        $a38372e2ae75f6c1$var$wasm.soundlawcomposition_insert(this.__wbg_ptr, index, law.__wbg_ptr);
    }
    /**
     * @param {number} index
     * @returns {SoundLaw}
     */ rm_law(index) {
        const ret = $a38372e2ae75f6c1$var$wasm.soundlawcomposition_rm_law(this.__wbg_ptr, index);
        return $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(ret);
    }
    /**
     * @param {SoundLaw} law
     */ add_law(law) {
        $a38372e2ae75f6c1$var$_assertClass(law, $a38372e2ae75f6c1$export$cf2277d9f7cc728b);
        $a38372e2ae75f6c1$var$wasm.soundlawcomposition_add_law(this.__wbg_ptr, law.__wbg_ptr);
    }
}
async function $a38372e2ae75f6c1$var$__wbg_load(module, imports) {
    if (typeof Response === "function" && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === "function") try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            if (module.headers.get("Content-Type") != "application/wasm") console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
}
function $a38372e2ae75f6c1$var$__wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $a38372e2ae75f6c1$var$handleError(function(arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_call_7cccdd69e0791ae2 = function() {
        return $a38372e2ae75f6c1$var$handleError(function(arg0, arg1, arg2) {
            const ret = arg0.call(arg1, arg2);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_error_7534b8e9a36f1ab4 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error($a38372e2ae75f6c1$var$getStringFromWasm0(arg0, arg1));
        } finally{
            $a38372e2ae75f6c1$var$wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbg_new_23a2665fac83c611 = function(arg0, arg1) {
        try {
            var state0 = {
                a: arg0,
                b: arg1
            };
            var cb0 = (arg0, arg1)=>{
                const a = state0.a;
                state0.a = 0;
                try {
                    return $a38372e2ae75f6c1$var$__wbg_adapter_65(a, state0.b, arg0, arg1);
                } finally{
                    state0.a = a;
                }
            };
            const ret = new Promise(cb0);
            return ret;
        } finally{
            state0.a = state0.b = 0;
        }
    };
    imports.wbg.__wbg_new_8a6f238a6ece86ea = function() {
        const ret = new Error();
        return ret;
    };
    imports.wbg.__wbg_newnoargs_105ed471475aaf50 = function(arg0, arg1) {
        const ret = new Function($a38372e2ae75f6c1$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbg_queueMicrotask_97d92b4fcc8a61c5 = function(arg0) {
        queueMicrotask(arg0);
    };
    imports.wbg.__wbg_queueMicrotask_d3219def82552485 = function(arg0) {
        const ret = arg0.queueMicrotask;
        return ret;
    };
    imports.wbg.__wbg_resolve_4851785c9c5f573d = function(arg0) {
        const ret = Promise.resolve(arg0);
        return ret;
    };
    imports.wbg.__wbg_soundlaw_new = function(arg0) {
        const ret = $a38372e2ae75f6c1$export$cf2277d9f7cc728b.__wrap(arg0);
        return ret;
    };
    imports.wbg.__wbg_stack_0ed75d68575b0f3c = function(arg0, arg1) {
        const ret = arg1.stack;
        const ptr1 = $a38372e2ae75f6c1$var$passStringToWasm0(ret, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        const len1 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        $a38372e2ae75f6c1$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $a38372e2ae75f6c1$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_88a902d13a557d07 = function() {
        const ret = typeof $parcel$global === "undefined" ? null : $parcel$global;
        return $a38372e2ae75f6c1$var$isLikeNone(ret) ? 0 : $a38372e2ae75f6c1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0 = function() {
        const ret = typeof globalThis === "undefined" ? null : globalThis;
        return $a38372e2ae75f6c1$var$isLikeNone(ret) ? 0 : $a38372e2ae75f6c1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_SELF_37c5d418e4bf5819 = function() {
        const ret = typeof self === "undefined" ? null : self;
        return $a38372e2ae75f6c1$var$isLikeNone(ret) ? 0 : $a38372e2ae75f6c1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_static_accessor_WINDOW_5de37043a91a9c40 = function() {
        const ret = typeof window === "undefined" ? null : window;
        return $a38372e2ae75f6c1$var$isLikeNone(ret) ? 0 : $a38372e2ae75f6c1$var$addToExternrefTable0(ret);
    };
    imports.wbg.__wbg_then_44b73946d2fb3e7d = function(arg0, arg1) {
        const ret = arg0.then(arg1);
        return ret;
    };
    imports.wbg.__wbindgen_cb_drop = function(arg0) {
        const obj = arg0.original;
        if (obj.cnt-- == 1) {
            obj.a = 0;
            return true;
        }
        const ret = false;
        return ret;
    };
    imports.wbg.__wbindgen_closure_wrapper1287 = function(arg0, arg1, arg2) {
        const ret = $a38372e2ae75f6c1$var$makeMutClosure(arg0, arg1, 295, $a38372e2ae75f6c1$var$__wbg_adapter_20);
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = $a38372e2ae75f6c1$var$wasm.__wbindgen_export_2;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof arg0 === "function";
        return ret;
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof obj === "string" ? obj : undefined;
        var ptr1 = $a38372e2ae75f6c1$var$isLikeNone(ret) ? 0 : $a38372e2ae75f6c1$var$passStringToWasm0(ret, $a38372e2ae75f6c1$var$wasm.__wbindgen_malloc, $a38372e2ae75f6c1$var$wasm.__wbindgen_realloc);
        var len1 = $a38372e2ae75f6c1$var$WASM_VECTOR_LEN;
        $a38372e2ae75f6c1$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $a38372e2ae75f6c1$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = $a38372e2ae75f6c1$var$getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($a38372e2ae75f6c1$var$getStringFromWasm0(arg0, arg1));
    };
    return imports;
}
function $a38372e2ae75f6c1$var$__wbg_init_memory(imports, memory) {}
function $a38372e2ae75f6c1$var$__wbg_finalize_init(instance, module) {
    $a38372e2ae75f6c1$var$wasm = instance.exports;
    $a38372e2ae75f6c1$var$__wbg_init.__wbindgen_wasm_module = module;
    $a38372e2ae75f6c1$var$cachedDataViewMemory0 = null;
    $a38372e2ae75f6c1$var$cachedUint8ArrayMemory0 = null;
    $a38372e2ae75f6c1$var$wasm.__wbindgen_start();
    return $a38372e2ae75f6c1$var$wasm;
}
function $a38372e2ae75f6c1$export$2ec80ee76a9348bf(module) {
    if ($a38372e2ae75f6c1$var$wasm !== undefined) return $a38372e2ae75f6c1$var$wasm;
    if (typeof module !== "undefined") {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn("using deprecated parameters for `initSync()`; pass a single object instead");
    }
    const imports = $a38372e2ae75f6c1$var$__wbg_get_imports();
    $a38372e2ae75f6c1$var$__wbg_init_memory(imports);
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $a38372e2ae75f6c1$var$__wbg_finalize_init(instance, module);
}
var $1399d63de771488f$exports = {};
$1399d63de771488f$exports = new URL("rust_capr_bg.d72026b8.wasm", import.meta.url).toString();


async function $a38372e2ae75f6c1$var$__wbg_init(module_or_path) {
    if ($a38372e2ae75f6c1$var$wasm !== undefined) return $a38372e2ae75f6c1$var$wasm;
    if (typeof module_or_path !== "undefined") {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn("using deprecated parameters for the initialization function; pass a single object instead");
    }
    if (typeof module_or_path === "undefined") module_or_path = new URL($1399d63de771488f$exports);
    const imports = $a38372e2ae75f6c1$var$__wbg_get_imports();
    if (typeof module_or_path === "string" || typeof Request === "function" && module_or_path instanceof Request || typeof URL === "function" && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    $a38372e2ae75f6c1$var$__wbg_init_memory(imports);
    const { instance: instance, module: module } = await $a38372e2ae75f6c1$var$__wbg_load(await module_or_path, imports);
    return $a38372e2ae75f6c1$var$__wbg_finalize_init(instance, module);
}
var $a38372e2ae75f6c1$export$2e2bcd8739ae039 = $a38372e2ae75f6c1$var$__wbg_init;




const $3ac2ddcc811b0b56$export$8d334790802d5608 = async (message, state)=>{
    let left;
    let right;
    let oldLeft = message.law.left;
    //great consistency in naming
    let oldright = message.law.right;
    if (typeof oldLeft == "string") left = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(oldLeft);
    else left = state.soundClasses.find((soundClass)=>soundClass.name == oldLeft.name).fst;
    if (typeof oldright == "string") right = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(oldright);
    else right = state.soundClasses.find((soundClass)=>soundClass.name == oldright.name).fst;
    let from = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(message.law.from); // account for when doing a sound law later
    let to = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(message.law.to); // account for when doing a sound law later
    let law = (0, $a38372e2ae75f6c1$export$b366fbedc27157db)(left, right, from, to);
    state.laws.push(law);
    state.composition.add_law(law); // mentions that null pointer passed to rust
    console.log("Finished computation");
    return {
        type: "FinishLoading",
        laws: state.laws,
        composition: state.composition
    };
};
const $3ac2ddcc811b0b56$export$9608d0eacffd6284 = (state)=>{
    state.output = state.composition.transduce_text(state.input);
    state.revereseOutput = state.composition.transduce_text(state.reverseInput);
    state.transducedFileStrings = state.fileStrings.map((s)=>state.composition.transduce_text(s));
    return state;
};
const $3ac2ddcc811b0b56$export$722fbec263ad908a = (message, state)=>{
    console.log("Found message: ", message);
    if (message.type === "AddSoundLaw") {
        state.soundLawInputs.push(message.law);
        state.isLoading = true;
        // Promise.resolve()
        //   .then(() => updateLaw(message, state))
        //   .then((res) => sendMessage(res));
        setTimeout(()=>$3ac2ddcc811b0b56$export$8d334790802d5608(message, state).then((msg)=>(0, $543d6d2a56ed7d8d$export$465cb47180de50f0)(msg)));
    //updateLaw(message, state).then((msg) => sendMessage(msg));
    } else if (message.type === "ChangeInput") {
        state.input = message.input;
        state.output = state.composition.transduce_text(state.input);
    } else if (message.type === "ChangeBackwardsInput") {
        state.reverseInput = message.input;
        state.revereseOutput = state.composition.transduce_text_invert(state.reverseInput);
    } else if (message.type === "FinishLoading") {
        state.isLoading = false;
        state.laws = message.laws;
        state.composition = message.composition;
        state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
    } else if (message.type === "UploadFile") {
        state.fileStrings = message.contents.split("\n").filter((x)=>x !== "").map((s)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(s));
        state.transducedFileStrings = state.fileStrings.map((s)=>state.composition.transduce_text(s));
        state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
    } else if (message.type === "ClickDelete") {
        state.composition.rm_law(message.index);
        state.laws.splice(message.index, 1);
        state.soundLawInputs.splice(message.index, 1);
        state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
    } else if (message.type === "Rearrange") {
        const oldIndex = message.old;
        const newIndex = message.new;
        const [movedInput] = state.soundLawInputs.splice(oldIndex, 1);
        const [movedLaw] = state.laws.splice(oldIndex, 1);
        state.laws.splice(newIndex, 0, movedLaw);
        state.soundLawInputs.splice(newIndex, 0, movedInput);
        state.composition = (0, $a38372e2ae75f6c1$export$9ab3471fa659f5a).new();
        state.laws.forEach((law)=>state.composition.add_law(law));
        state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
    } else if (message.type === "Transduce") state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
    else if (message.type === "DragStart") state.drag = {
        type: "DraggingOver",
        old: message.index,
        new: message.index
    }; // start with dragging over self
    else if (message.type === "DragOver") {
        if (state.drag.type == "DraggingOver") state.drag.new = message.index;
        else console.log("Drag over called without first starting a drag");
    } else if (message.type === "DragEnd") {
        if (state.drag.type == "DraggingOver") {
            const oldIndex = state.drag.old;
            const newIndex = state.drag.new;
            const [movedLaw] = state.laws.splice(oldIndex, 1);
            state.laws.splice(newIndex, 0, movedLaw);
            state.composition = (0, $a38372e2ae75f6c1$export$9ab3471fa659f5a).new();
            state.laws.forEach((law)=>state.composition.add_law(law));
            state = $3ac2ddcc811b0b56$export$9608d0eacffd6284(state);
            state.drag.type = "NoDrag";
        } else console.log("Drag over called without first starting a drag");
    } else if (message.type === "Save") {
        localStorage.setItem("classes", JSON.stringify(state.soundClasses));
        localStorage.setItem("laws", JSON.stringify(state.soundLawInputs));
        console.log("Storing classes");
    } else if (message.type === "Load") {
        const classesStorage = localStorage.getItem("classes");
        if (classesStorage) state.soundClasses = JSON.parse(classesStorage);
        const storage = localStorage.getItem("laws");
        if (storage) {
            state.composition = (0, $a38372e2ae75f6c1$export$9ab3471fa659f5a).new();
            state.laws = [];
            state.soundLawInputs = [];
            const laws = JSON.parse(storage);
            state.isLoading = true;
            setTimeout(()=>laws.forEach((law)=>{
                    state.soundLawInputs.push(law);
                    $3ac2ddcc811b0b56$export$8d334790802d5608({
                        type: "AddSoundLaw",
                        law: law
                    }, state).then((msg)=>(0, $543d6d2a56ed7d8d$export$465cb47180de50f0)(msg));
                }));
        }
    } else if (message.type === "ChangeRegexType") state.regexType = message.regex;
    else if (message.type === "AddSoundClass") {
        let regexType = message.regex;
        let fst;
        if (regexType.type == "Disjunction") {
            let regexfsts = message.sounds.map((sound)=>(0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(sound));
            fst = regexfsts[0]; // should check to make sure it is not emty
            regexfsts.slice(1).forEach((r)=>fst.disjoint(r)); //theoritcally works by doing dijsoint with self, but rust prevents this
        } else if (regexType.type == "Concat") {
            let regexfsts = message.sounds.map((sound)=>// todo fix this
                state.soundClasses.find((soundClass)=>soundClass.name == sound).fst);
            fst = regexfsts[0]; // should check to make sure it is not emty
            regexfsts.slice(1).forEach((r)=>fst.concat(r)); //theoritcally works by doing dijsoint with self, but rust prevents this
        } else // todo! fix this
        fst = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa("error");
        state.soundClasses.push({
            type: message.regex,
            name: message.name,
            sounds: message.sounds,
            fst: fst
        });
    } else //whatever
    console.log("Very bad, message was not found");
    return {
        ...state
    }; //change this
};




const $7b8c826a37035144$export$ac889f49e6e00228 = ()=>{
    const uploadFile = document.getElementById("upload");
    uploadFile.addEventListener("change", async ()=>{
        if (uploadFile.files) {
            let file = uploadFile.files[0];
            const text = await file.text();
            (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
                type: "UploadFile",
                contents: text
            });
        } else (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "UploadFile",
            contents: ""
        });
    });
    const left = document.getElementById("left-input");
    const right = document.getElementById("right-input");
    const to = document.getElementById("to");
    const from = document.getElementById("from");
    const createButton = document.getElementById("create-law");
    createButton.addEventListener("click", ()=>{
        const leftSelect = document.querySelector("#left-select");
        const rightSelect = document.querySelector("#right-select");
        let l = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(left.value);
        let r = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(right.value);
        if (leftSelect.value !== "") l = {
            name: leftSelect.value
        };
        if (rightSelect.value !== "") r = {
            name: rightSelect.value
        };
        (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "AddSoundLaw",
            law: {
                left: l,
                right: r,
                from: (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(from.value),
                to: (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(to.value)
            }
        });
    });
    const input = document.getElementById("input");
    const backwards = document.getElementById("backward");
    input?.addEventListener("input", ()=>(0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "ChangeInput",
            input: input.value
        }));
    backwards?.addEventListener("input", ()=>(0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "ChangeBackwardsInput",
            input: backwards.value
        }));
    const saveButton = document.getElementById("save");
    const loadButton = document.getElementById("load");
    saveButton.addEventListener("click", ()=>{
        (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "Save"
        });
    });
    loadButton.addEventListener("click", ()=>{
        (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "Load"
        });
    });
    const regexSelect = document.getElementById("regex");
    regexSelect.addEventListener("input", (e)=>{
        (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "ChangeRegexType",
            regex: {
                type: regexSelect.value
            }
        });
    });
    const createSoundLine = document.querySelector(".create-sound-class");
    createSoundLine.addEventListener("click", ()=>{
        const inputPhonemes = document.querySelector(".phonemes-input");
        const namePhonemes = document.querySelector(".phonemes-name");
        if (inputPhonemes && namePhonemes) (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "AddSoundClass",
            regex: {
                type: "Disjunction"
            },
            name: namePhonemes.value,
            sounds: inputPhonemes.value.split(" ").map((p)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(p))
        });
        const inputConcat = document.querySelector(".concat-input");
        const nameConcat = document.querySelector(".concat-name");
        if (inputConcat && nameConcat) (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
            type: "AddSoundClass",
            regex: {
                type: "Concat"
            },
            name: nameConcat.value,
            sounds: inputConcat.value.split(" ")
        });
    });
};
const $7b8c826a37035144$export$b3890eb0ae9dca99 = (state)=>{
    console.log("Starting rendering with state ", state);
    const loading = document.getElementById("loading");
    if (loading) {
        if (state.isLoading) loading.style.display = "block";
        else loading.style.display = "none";
    }
    const output = document.getElementById("output");
    output.innerHTML = state.output.map((x)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(x.replaceAll(" ", ""))).join("\n");
    const backwardsOutput = document.getElementById("backwards-output");
    backwardsOutput.innerHTML = state.revereseOutput.map((x)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(x.replaceAll(" ", ""))).join("\n");
    const rulesList = document.getElementById("rulesList");
    rulesList.innerHTML = "";
    state.soundLawInputs.forEach((x, index)=>{
        let left = "";
        if (typeof x.left == "string") left = x.left;
        else left = x.left.name;
        let right = "";
        if (typeof x.right == "string") right = x.right;
        else right = x.right.name;
        let s = `Rule: ${x.from} \u{2192} ${x.to} / ${left} _ ${right}`;
        const listItem = document.createElement("li");
        listItem.textContent = s;
        listItem.draggable = true;
        const deleteButton = document.createElement("button");
        deleteButton.textContent = "Delete";
        deleteButton.classList.add("delete-button");
        deleteButton.addEventListener("click", ()=>{
            (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
                type: "ClickDelete",
                index: index
            });
        });
        const list = document.getElementById("rulesList");
        const input = document.createElement("input");
        const button = document.createElement("button");
        button.innerHTML = "Click to Move Index";
        button.addEventListener("click", ()=>{
            const newIndex = parseInt(input.value, 10) - 1; // because lists are 1 based
            if (!isNaN(newIndex)) (0, $543d6d2a56ed7d8d$export$465cb47180de50f0)({
                type: "Rearrange",
                old: index,
                new: newIndex
            });
            else console.log("Invalid index input");
        });
        listItem.appendChild(deleteButton);
        listItem.appendChild(input);
        listItem.appendChild(button);
        rulesList.appendChild(listItem);
    });
    if (state.drag.type == "DraggingOver") rulesList.insertBefore(rulesList.children[state.drag.old], rulesList.children[state.drag.new]);
    let table = document.getElementById("file-inputs");
    table.innerHTML = ' <thead> <tr id="file-headers"></tr> </thead> ';
    let tableHeader = document.getElementById("file-headers");
    state.fileStrings.forEach((line)=>{
        const item = document.createElement("th");
        item.textContent = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(line);
        tableHeader.appendChild(item);
    });
    if (state.transducedFileStrings.length > 0) {
        const transpose = state.transducedFileStrings[0].map((_, index)=>state.transducedFileStrings.map((row)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(row[index].replaceAll(" ", ""))));
        transpose.forEach((row)=>{
            const htmlRow = document.createElement("tr");
            row.forEach((col)=>{
                const item = document.createElement("td");
                item.textContent = col;
                htmlRow.appendChild(item);
            });
            table.append(htmlRow);
        });
    }
    // sound class
    const phonemes = document.querySelector(".phonemes-name");
    if (state.regexType.type == "Disjunction" && phonemes == null) {
        const area = document.querySelector(".sound-class-area");
        area.innerHTML = "";
        const nameDiv = document.createElement("div");
        const nameHeader = document.createElement("p");
        nameHeader.innerHTML = "Name";
        nameDiv.append(nameHeader);
        const name = document.createElement("input");
        name.classList.add("phonemes-name");
        nameDiv.append(name);
        area?.append(nameDiv);
        const instructions = document.createElement("p");
        instructions.innerHTML = "Put the phonemes with one space between each one";
        const phonemes = document.createElement("input");
        phonemes.classList.add("phonemes-input");
        area?.append(instructions);
        area?.append(phonemes);
    } else if (state.regexType.type == "Concat" && document.querySelector(".concat-name") == null) {
        const area = document.querySelector(".sound-class-area");
        area.innerHTML = "";
        const nameDiv = document.createElement("div");
        const nameHeader = document.createElement("p");
        nameHeader.innerHTML = "Name";
        nameDiv.append(nameHeader);
        const name = document.createElement("input");
        name.classList.add("concat-name");
        nameDiv.append(name);
        area?.append(nameDiv);
        const instructions = document.createElement("p");
        instructions.innerHTML = "Put the sound classes with one space in between";
        const phonemes = document.createElement("input");
        phonemes.classList.add("concat-input");
        area?.append(instructions);
        area?.append(phonemes);
    }
    // show sound rules
    const soundList = document.querySelector("#sound-classes");
    if (soundList) {
        soundList.innerHTML = "";
        state.soundClasses.forEach((sound)=>{
            const li = document.createElement("li");
            li.innerHTML = `${sound.name}: ${sound.sounds.join(",")}`;
            soundList.append(li);
        });
    }
    const leftSelect = document.querySelector("#left-select");
    const rightSelect = document.querySelector("#right-select");
    leftSelect.innerHTML = "<option value=''> Custom </option> ";
    rightSelect.innerHTML = "<option value=''> Custom </option> ";
    state.soundClasses.forEach((law)=>{
        const leftNode = document.createElement("option");
        leftNode.innerHTML = law.name;
        leftNode.value = law.name;
        const rightNode = document.createElement("option");
        rightNode.innerHTML = law.name;
        rightNode.value = law.name;
        leftSelect.append(leftNode);
        rightSelect.append(rightNode);
    });
    console.log("Finished rendering");
};




class $94af80b731d12263$export$94143951f9f944d3 {
    constructor(setLoadingListiner, createSoundLawListner, soundClasses){
        this.createSoundLawListner = createSoundLawListner;
        this.setLoadingListener = setLoadingListiner;
        this.soundClasses = soundClasses;
        this.left = document.getElementById("left-input");
        this.right = document.getElementById("right-input");
        this.to = document.getElementById("to");
        this.from = document.getElementById("from");
        this.leftSelect = document.querySelector("#left-select");
        this.rightSelect = document.querySelector("#right-select");
        this.createButton = document.getElementById("create-law");
        this.createButton.addEventListener("click", ()=>{
            this.setLoadingListener();
            let leftRegex;
            let rightRegex;
            let fromRegex;
            let toRegex;
            let l = this.left.value;
            let r = this.right.value;
            if (this.leftSelect.value === "") leftRegex = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(this.left.value);
            else // actually check for undefined
            leftRegex = soundClasses.get(this.leftSelect.value);
            if (this.rightSelect.value === "") rightRegex = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(this.right.value);
            else // actually check for undefined
            rightRegex = soundClasses.get(this.rightSelect.value);
            fromRegex = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(this.from.value);
            toRegex = (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(this.to.value);
            setTimeout(()=>// create the new law
                this.createSoundLawListner(leftRegex, rightRegex, fromRegex, toRegex));
        });
    }
    //take the soundClasses, and updates the selectHTmls with these options
    updateSoundClasses() {
        for (const [key, value] of this.soundClasses){
            // should check if the value is already in the select
            // if it is, skip it
            if (this.leftSelect.querySelector(`option[value="${key}"]`) || this.rightSelect.querySelector(`option[value="${key}"]`)) continue;
            const option = document.createElement("option");
            option.value = key;
            option.text = key;
            this.leftSelect.appendChild(option);
            this.rightSelect.appendChild(option.cloneNode(true));
        }
    }
}



class $7ecad0e55b149e45$export$b2d3c42d6fbba356 {
    constructor(transduceListener, transducer){
        this.transduceListner = transduceListener;
        this.tranducer = transducer;
        this.table = document.getElementById("file-inputs");
        this.tableHeader = document.getElementById("file-headers");
        this.uploadFile = document.getElementById("upload");
        this.fileStrings = [];
        this.uploadFile.addEventListener("change", async ()=>{
            if (this.uploadFile.files) {
                let file = this.uploadFile.files[0];
                const text = await file.text();
                this.fileStrings = text.split("\n").filter((x)=>x !== "");
                this.transduceListner();
                this.renderHeader();
            } else this.fileStrings = [];
        });
    }
    renderHeader() {
        let newChildren = this.fileStrings.map((text)=>{
            const elem = document.createElement("th");
            elem.textContent = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(text);
            return elem;
        });
        this.tableHeader.replaceChildren(...newChildren);
    }
    transduce() {
        let body = this.table.querySelector("tbody");
        if (!body) {
            body = document.createElement("tbody");
            this.table.appendChild(body);
        }
        const transduced = this.fileStrings.map((s)=>this.tranducer.transduce_text(s));
        if (transduced[0]) {
            const transpose = transduced[0].map((_, index)=>transduced.map((row)=>{
                    if (!row[index]) return "";
                    return (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(row[index].replaceAll(" ", ""));
                }));
            const newChildren = transpose.map((r)=>{
                const row = document.createElement("tr");
                const rowElements = r.map((d)=>{
                    const data = document.createElement("td");
                    data.innerText = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(d);
                    return data;
                });
                row.append(...rowElements);
                return row;
            });
            body.replaceChildren(...newChildren);
        } else body.replaceChildren();
    }
}



class $77a27b797b4319a2$export$f3c416fd76e3334e {
    constructor(composition){
        this.composition = composition;
        this.input = document.getElementById("input");
        this.backwards = document.getElementById("backward");
        this.output = document.getElementById("output");
        this.backwardsOutput = document.getElementById("backwards-output");
        this.input.addEventListener("input", ()=>{
            this.transduce();
        });
        this.backwards.addEventListener("input", ()=>{
            this.transduce();
        });
    }
    transduce() {
        let r = this.composition.transduce_text_invert(this.backwards.value);
        this.backwardsOutput.innerHTML = r.map((x)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(x.replaceAll(" ", ""))).join("\n");
        let o = this.composition.transduce_text(this.input.value);
        this.output.innerHTML = o.map((x)=>(0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(x.replaceAll(" ", ""))).join("\n");
    }
}



class $6f3daf952adcfbf9$export$4ecda0163efe6d1d {
    constructor(soundClasses, laws, loadListen){
        this.loadListen = loadListen;
        this.laws = laws;
        this.soundClasses = soundClasses;
        this.saveButton = document.getElementById("save");
        this.loadButton = document.getElementById("load");
        this.saveButton.addEventListener("click", ()=>{
            // ideally make this smarter
            let stringMap = new Map();
            this.soundClasses.forEach((v, k)=>{
                console.log(v.to_json());
                stringMap.set(k, v.to_json());
            });
            localStorage.setItem("classes", JSON.stringify(stringMap));
            //console.log(this.soundClasses);
            console.log(stringMap);
            console.log("Sound Classes");
            console.log(JSON.stringify(stringMap));
            let soundLawStrings = this.laws.map((x)=>x.to_json());
            localStorage.setItem("laws", JSON.stringify(soundLawStrings));
            console.log("Laws");
            console.log(JSON.stringify(soundLawStrings));
            alert("Saved!");
        });
        this.loadButton.addEventListener("click", ()=>{
            //alert("Broken right now, don't use this");
            const classesStorage = localStorage.getItem("classes");
            if (classesStorage) {
                let classes = JSON.parse(classesStorage);
                classes.forEach((v, k)=>{
                    this.soundClasses.set(k, (0, $a38372e2ae75f6c1$export$9354ed65840f0c28).from_json(v));
                });
            } else alert("No sound classes found");
            const storage = localStorage.getItem("laws");
            if (storage) {
                const laws = JSON.parse(storage);
                const parsed = laws.map((s)=>(0, $a38372e2ae75f6c1$export$cf2277d9f7cc728b).from_json(s));
                this.laws.push(...parsed);
            } else alert("No sound laws were found");
            loadListen();
        });
    }
}



class $9f7a415f11e5ed7d$export$ce1b7cc09e76eb85 {
    constructor(soundClassesMap, addSoundClassListener){
        this.addSoundClassListener = addSoundClassListener;
        this.soundClassesMap = soundClassesMap;
        this.area = document.querySelector(".sound-class-area");
        this.regexSelect = document.getElementById("regex");
        this.regexType = {
            type: this.regexSelect.value
        };
        this.regexSelect.addEventListener("input", (e)=>{
            if (this.regexType.type != this.regexSelect.value) {
                this.regexType = {
                    type: this.regexSelect.value
                };
                this.render();
            }
        });
        this.createSoundClass = document.querySelector(".create-sound-class");
        this.createSoundClass.addEventListener("click", ()=>{
            let nameValue = this.name.value;
            let sounds = (0, $a38372e2ae75f6c1$export$a7b0fdfe265e688f)(this.phonemes.value).split(" ");
            if (this.regexType.type == "Disjunction") {
                let regexfsts = sounds.map((sound)=>(0, $a38372e2ae75f6c1$export$9354ed65840f0c28).new_from_ipa(sound));
                if (regexfsts.length == 0) {
                    alert("don't make something with empty sounds");
                    return;
                }
                let fst = regexfsts[0]; // should check to make sure it is not emty
                regexfsts.slice(1).forEach((r)=>fst.disjoint(r)); //theoritcally works by doing dijsoint with self, but rust prevents this
                this.soundClassesMap.set(nameValue, fst);
            } else if (this.regexType.type == "Concat") {
                let bad = false;
                let regexfsts = sounds.map((sound)=>{
                    let f = this.soundClassesMap.get(sound);
                    if (!f) {
                        alert(`Sound class for ${sound} not found`);
                        bad = true;
                        return;
                    }
                    return f.dup();
                });
                if (bad) return;
                if (regexfsts.length == 0) {
                    alert("Sound classes was empty");
                    return;
                }
                let fst = regexfsts[0]; // should check to make sure it is not emty
                regexfsts.slice(1).forEach((r)=>fst.concat(r)); //theoritcally works by doing dijsoint with self, but rust prevents this
                this.soundClassesMap.set(nameValue, fst);
            }
            this.renderSoundClassDisplay();
            this.addSoundClassListener();
        });
    }
    renderSoundClassDisplay() {
        const soundList = document.querySelector("#sound-classes");
        if (soundList) {
            soundList.innerHTML = "";
            this.soundClassesMap.forEach((fst, name)=>{
                const li = document.createElement("li");
                li.innerHTML = `${name}: ${fst.string_form()}`;
                soundList.append(li);
            });
        }
    }
    render() {
        this.area.innerHTML = ""; // probably should do this the right way
        let instructions = "";
        if (this.regexType.type == "Disjunction") instructions = "Put the phonemes with one space between each one";
        else if (this.regexType.type == "Concat") instructions = "Put the sound classes with one space in between";
        else {
            alert("This sound class is not yet supported");
            return;
        }
        const nameDiv = document.createElement("div");
        const nameHeader = document.createElement("p");
        nameHeader.innerHTML = "Name";
        nameDiv.append(nameHeader);
        this.name = document.createElement("input");
        this.name.classList.add("name");
        nameDiv.append(this.name);
        this.area?.append(nameDiv);
        const instructionsElem = document.createElement("p");
        instructionsElem.innerHTML = "Put the phonemes with one space between each one";
        this.phonemes = document.createElement("input");
        this.phonemes.classList.add("input");
        this.area?.append(instructionsElem);
        this?.area.append(this.phonemes);
    }
}


class $a6938941c5fca0e7$export$90b7dae74ce74195 {
    constructor(laws, deleteListner, rearrangeListener){
        this.rearrangeListener = rearrangeListener;
        this.laws = laws;
        this.deleteListner = deleteListner;
        this.rulesList = document.getElementById("rulesList");
    }
    render() {
        this.rulesList.replaceChildren();
        // console.log(this.laws);
        this.laws.forEach((x, index)=>{
            let left = x.get_left_context();
            let right = x.get_right_context();
            let s = `Rule: ${x.get_from()} \u{2192} ${x.get_to()} / ${left} _ ${right}`;
            const listItem = document.createElement("li");
            listItem.textContent = s;
            listItem.draggable = true;
            const deleteButton = document.createElement("button");
            deleteButton.textContent = "Delete";
            deleteButton.classList.add("delete-button");
            deleteButton.addEventListener("click", ()=>{
                this.deleteListner(index);
            });
            const list = document.getElementById("rulesList");
            const input = document.createElement("input");
            const button = document.createElement("button");
            button.innerHTML = "Click to Move Index";
            button.addEventListener("click", ()=>{
                const newIndex = parseInt(input.value, 10) - 1; // because lists are 1 based
                if (!isNaN(newIndex)) this.rearrangeListener(index, newIndex);
                else console.log("Invalid index input");
            });
            listItem.appendChild(deleteButton);
            listItem.appendChild(input);
            listItem.appendChild(button);
            this.rulesList.appendChild(listItem);
        });
    }
}


class $3d7d3d675a7beea0$export$861edd1ccea2f746 {
    constructor(){
        this.laws = [];
        this.soundClassesMap = new Map();
        this.composition = (0, $a38372e2ae75f6c1$export$9ab3471fa659f5a).new();
        this.forwardBackwards = new (0, $77a27b797b4319a2$export$f3c416fd76e3334e)(this.composition);
        this.saveButton = new (0, $6f3daf952adcfbf9$export$4ecda0163efe6d1d)(this.soundClassesMap, this.laws, ()=>{
            this.soundClassArea.renderSoundClassDisplay();
            this.soundLawDisplay.render();
            this.createSoundLaw.updateSoundClasses();
        });
        this.soundClassArea = new (0, $9f7a415f11e5ed7d$export$ce1b7cc09e76eb85)(this.soundClassesMap, ()=>{
            this.createSoundLaw.updateSoundClasses();
        });
        let deleteListener = (index)=>{
            this.composition.rm_law(index);
            this.laws.splice(index, 1);
            // state.soundLawInputs.splice(message.index, 1);
            this.transduce();
            this.soundLawDisplay.render();
        };
        let rearrangeListener = (from, to)=>{
            const oldIndex = from;
            const newIndex = to;
            // const [movedInput] = this.soundLawInputs.splice(oldIndex, 1);
            const [movedLaw] = this.laws.splice(oldIndex, 1);
            this.laws.splice(newIndex, 0, movedLaw);
            // this.soundLawInputs.splice(newIndex, 0, movedInput);
            this.composition.clear();
            //probably not that that efficient
            this.laws.forEach((law)=>this.composition.add_law(law));
            this.transduce();
            this.soundLawDisplay.render();
        };
        this.soundLawDisplay = new (0, $a6938941c5fca0e7$export$90b7dae74ce74195)(this.laws, deleteListener, rearrangeListener);
        // javascript is so stupid, so I have to use () => this.transduce
        this.fileArea = new (0, $7ecad0e55b149e45$export$b2d3c42d6fbba356)(()=>this.transduce(), this.composition);
        this.createSoundLaw = new (0, $94af80b731d12263$export$94143951f9f944d3)(()=>this.displayLoadingScreen(true), (a, b, c, d)=>{
            this.addSoundLaw(a, b, c, d);
            this.displayLoadingScreen(false);
            this.soundLawDisplay.render();
        }, this.soundClassesMap);
        this.loadingScreen = document.getElementById("loading");
    }
    transduce() {
        this.fileArea.transduce();
        this.forwardBackwards.transduce();
    }
    displayLoadingScreen(loading) {
        if (loading) this.loadingScreen.style.display = "block";
        else this.loadingScreen.style.display = "none";
    }
    addSoundLaw(leftRegex, rightRegex, fromRegex, toRegex) {
        let law = (0, $a38372e2ae75f6c1$export$b366fbedc27157db)(leftRegex, rightRegex, fromRegex, toRegex);
        this.laws.push(law);
        //composition also has some dupliation, since the laws should laready be inside it, so I hsould redeisng this to also remove thsi redundancy
        this.composition.add_law(law); // mentions that null pointer passed to rust
    }
}


let $543d6d2a56ed7d8d$export$465cb47180de50f0 = (_)=>{
    console.log("Send Message not initialize properly");
};
// import { Drawable } from "./krist_lib/editor";
// import Victor from "victor";
// import { RuleNode } from "./krist_lib/rule-node";
async function $543d6d2a56ed7d8d$var$run() {
    await (0, $a38372e2ae75f6c1$export$2e2bcd8739ae039)();
    let state = {
        soundClasses: [],
        regexType: {
            type: "Union"
        },
        isLoading: false,
        soundLawInputs: [],
        laws: [],
        input: "",
        output: [],
        reverseInput: "",
        revereseOutput: [],
        composition: (0, $a38372e2ae75f6c1$export$9ab3471fa659f5a).new(),
        fileStrings: [],
        transducedFileStrings: [],
        drag: {
            type: "NoDrag"
        }
    };
    $543d6d2a56ed7d8d$export$465cb47180de50f0 = (message)=>{
        state = (0, $3ac2ddcc811b0b56$export$722fbec263ad908a)(message, state);
        //state = message.updateState(state); //todo: refactor this in
        (0, $7b8c826a37035144$export$b3890eb0ae9dca99)(state);
    };
    // switch to new method
    // renderInit();
    let main = new (0, $3d7d3d675a7beea0$export$861edd1ccea2f746)();
    main.transduce();
}
$543d6d2a56ed7d8d$var$run();


//# sourceMappingURL=index.787779be.js.map
